import {NOTIFICATION_TYPES, SECTIONS} from "../../../../config/constants";
import PageHead from "../../../layout/PageHead";
import {
  Empty,
  Tabs,
  Select,
  Button,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Checkbox,
  InputNumber,
  Menu,
  Image,
} from "antd";
import "./Account.css";
import { SmileOutlined, EditOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../../redux/actions";
import hrFlag from "../../../../img/languages/hr.svg";
import usFlag from "../../../../img/languages/us.svg";
import nlFlag from "../../../../img/languages/nl.svg";
import frFlag from "../../../../img/languages/fr.svg";
import {ROUTES} from "../../../../config/consts/routes";
import ApplicationService from "../../../../services/application/ApplicationService";
import NotificationsUtil from "../../../shared/utils/NotificationsUtil";
import {
  GLOBAL_COMPONENT,
  GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT,
} from "../../../../config/consts/appsettings";

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.administration.name,
  },
  {
    path: ROUTES.administration.account.route,
    breadcrumbName: ROUTES.administration.account.name,
  },
];

const Account = () => {
  const { language, profile } = useSelector((state: any) => ({
    language: state.language,
    profile: state.profile,
  }));

  const dispatch = useDispatch();
  
  const [preferencesForm] = Form.useForm();
  const { t, i18n } = useTranslation("translations");
  const { Option } = Select;
  const { TextArea } = Input;

  const [selectedTable, setSelectedTable] = useState<any>(null);
  const [selectedField, setSelectedField] = useState<any>(null);

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [selectedItem, setSelectedItem] = useState<any>("accountInfo");
  const [editActive, setEditActive] = useState(false);

  const [preferences, setPreferences] = useState<any>([]);
  const [components, setComponents] = useState<any>([]);
  const [defaultGroupCode, setDefaultGroupCode] = useState<any>(undefined);

  useEffect(() => {
    document.title = ROUTES.administration.account.name;
  }, []);

  const accountMenu = [
    { label: "Account info", key: "accountInfo" },
    { label: "Change password", key: "changePassword" },
    { label: "Preferences", key: "preferences" },
  ];

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };

  const editEnabled = () => {
    setEditActive(true);
  };

  const handleOptionMenuClick = (e: any) => {
    const val = accountMenu.find((x: any) => x.key.toString() === e.key);
    setSelectedItem(val?.key);
  };

  useEffect(() => {
    // setSelectedItem(undefined);
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
    ApplicationService.getPreferences().then((response: any) => {
      const data = response.data;
      setPreferences(data);
    })
    ApplicationService.getComponents().then((response: any) => {
      const data = response.data;
      setComponents(data)
    })
  }, []);

  const onClickLanguageChange = (language: string) => {
    dispatch(setLanguage(language));
  }

  useEffect(() => {
    if (preferences?.length > 0 && components?.length > 0 && profile && groupCodes?.length > 0 && !defaultGroupCode) {
      const existingPreference = preferences.find(x =>
          x.componentId === components.find((x:any) => x.name === GLOBAL_COMPONENT)?.id &&
          x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
          x.object === "User" &&
          x.objectId.toString() === profile.id.toString());
      
      if (existingPreference) {
        setDefaultGroupCode(existingPreference.value)
        preferencesForm.setFieldsValue({ defaultGroupCode: existingPreference.value });
      }
    }
  }, [preferences, components, profile, groupCodes]);

  const onClickGroupCodeChange = (groupCode: string) => {
    const existingPreference = preferences.find(x =>
        x.componentId === components.find((x:any) => x.name === GLOBAL_COMPONENT)?.id &&
        x.key === GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT &&
        x.object === "User" &&
        x.objectId.toString() === profile.id.toString());
    
    if (!groupCode && existingPreference) {
      ApplicationService.deletePreference(existingPreference.id)
          .then((response: any) => {
            NotificationsUtil.openNotificationDialog({
              description: t(
                  "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
                  {
                    lngs: i18n.languages,
                    defaultValue: "GroupCode preference successfully saved",
                  }
              )!,
              type: NOTIFICATION_TYPES.SUCCESS,
              logError: false,
            });
          })
          .catch((error: any) => {
            NotificationsUtil.openNotificationDialog({
              description: error.response.data,
              type: NOTIFICATION_TYPES.ERROR,
              logError: true,
            });
          });
      return;
    }
    
    if (!groupCode) {
      return;
    }
    
    let model : any = {
      componentId: components.find((x:any) => x.name === GLOBAL_COMPONENT)?.id,
      key: GLOBAL_COMPONENT_FILTER_GROUPCODE_DEFAULT,
      object: "User",
      objectId: profile.id.toString(),
      value: groupCode,
    }

    if (existingPreference) {
      ApplicationService.updatePreference(existingPreference.id, model).then((response:any) => {
        NotificationsUtil.openNotificationDialog({
          description: t(
              "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "GroupCode preference successfully saved",
              }
          )!,
          placement: "bottomRight",
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        })
        ApplicationService.getPreferences().then((response: any) => {
          const data = response.data;
          setPreferences(data)
        })
      })
    } else {
      ApplicationService.createPreference(model).then((response:any) => {
        NotificationsUtil.openNotificationDialog({
          description: t(
              "Page.Administration.Account.Preferences.GroupCodePreferenceUpdateSuccessDescription",
              {
                lngs: i18n.languages,
                defaultValue: "GroupCode preference successfully saved",
              }
          )!,
          placement: "bottomRight",
          type: NOTIFICATION_TYPES.SUCCESS,
          logError: false,
        })
        ApplicationService.getPreferences().then((response: any) => {
          const data = response.data;
          setPreferences(data)
        })
      })
    }
  }

  useEffect(() => {
    if (language) {
      preferencesForm.setFieldsValue({ chooseLanguage: language });
    } else {
      preferencesForm.setFieldsValue({ chooseLanguage: 'en' });
    }
  }, [language])

  return (
    <div>
      <PageHead
        title={t("Page.Administration.MyAccount.Headers.MyAccount", {
          lngs: i18n.languages,
          defaultValue: "My account",
        })}
        icon={<SmileOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={false}
        setSelectEntityDisabled={false}
        setSelectOperationDisabled={false}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div className="acc-body-container">
        <div className="left-container">
          <Menu
            items={accountMenu.map((item: any) => {
              return {
                key: item.key,
                label: item.label,
              };
            })}
            selectedKeys={[selectedItem]}
            defaultSelectedKeys={["accountInfo"]}
            onClick={handleOptionMenuClick}
          />
        </div>
        <div className="right-container">
          <div className="title-actions">
            <div>
              <span style={{ color: "var(--primary)" }}>Account info</span>
            </div>
            <div className="action-buttons">
              <Button
                onClick={editEnabled}
                type="ghost"
                size="small"
                icon={<EditOutlined />}
              >
                Edit
              </Button>
            </div>
          </div>
          <Divider />
          {selectedItem === "accountInfo" && (
            <div className="overview-section">
              <table>
                <tr>
                  <td>First Name</td>
                  <td>First Name</td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>Last Name</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>email@email.com</td>
                </tr>
                <tr>
                  <td>Date Created</td>
                  <td>01.01.2022</td>
                </tr>
                <tr>
                  <td>Is Admin</td>
                  <td>true</td>
                </tr>
                <tr>
                  <td>Assigned Roles</td>
                  <td>none</td>
                </tr>
              </table>
            </div>
          )}
          {selectedItem === "accountInfo" && editActive && (
            <div className="edit-section">
              <Form layout="vertical" size="small" style={{ width: "50%" }}>
                <Form.Item label="First Name:">
                  <Input
                    placeholder="first name"
                    value={""}
                    // onChange={onSelectedEntityNameChange}
                  />
                </Form.Item>
                <Form.Item label="Last Name:">
                  <Input
                    placeholder="last name"
                    value={""}
                    // onChange={onSelectedEntityNameChange}
                  />
                </Form.Item>
                <Form.Item label="Email:">
                  <Input
                    placeholder="email"
                    value={""}
                    // onChange={onSelectedEntityNameChange}
                  />
                </Form.Item>
                <Form.Item label="Date created:">
                  <Input
                    disabled
                    placeholder="date"
                    value={"01.01.2022"}
                    // onChange={onSelectedEntityNameChange}
                  />
                </Form.Item>
              </Form>
            </div>
          )}
          {selectedItem === "changePassword" && (
            <div className="change-password-section">
              <Form
                layout="vertical"
                size="small"
                style={{ width: "50%" }}
                validateMessages={validateMessages}
              >
                <Form.Item
                  label="Enter current password"
                  name="oldPassword"
                  rules={[{ required: true }]}
                >
                  <Input.Password placeholder="enter value" />
                </Form.Item>
                <Form.Item label="Enter new password" name="newPassword">
                  <Input.Password placeholder="enter value" />
                </Form.Item>
                <Form.Item label="Confirm new password" name="confirmPassword">
                  <Input.Password placeholder="enter value" />
                </Form.Item>
              </Form>
            </div>
          )}
          {selectedItem === "preferences" && (
            <div className="change-password-section">
              <Form
                layout="vertical"
                size="small"
                style={{ width: "50%" }}
                validateMessages={validateMessages}
                form={preferencesForm}
              >
                <Form.Item
                  label="Choose language"
                  name="chooseLanguage"
                >
                  <Select onChange={onClickLanguageChange} value={language}>
                    <Option value="en">
                      English 
                      <Image src={usFlag} style={{ paddingLeft: "10px", height: "10px" }} preview={false}></Image> 
                    </Option>
                    <Option value="hr">
                      Croatian
                      <Image src={hrFlag} style={{ paddingLeft: "10px", height: "10px" }} preview={false}></Image> 
                    </Option>
                    <Option value="nl">
                      Dutch
                      <Image src={nlFlag} style={{ paddingLeft: "10px", height: "10px" }} preview={false}></Image> 
                    </Option>
                    <Option value="fr">
                      French
                      <Image src={frFlag} style={{ paddingLeft: "10px", height: "10px" }} preview={false}></Image> 
                    </Option>
                  </Select>
                </Form.Item>
                <Form.Item
                    label="Choose default Group Code"
                    name="defaultGroupCode"
                >
                  <Select
                    placeholder="Group Code"
                    onChange={onClickGroupCodeChange}
                    onClear={() => onClickGroupCodeChange(undefined)}
                    showSearch={true}
                    showArrow={true}
                    allowClear={true}
                    value={defaultGroupCode}
                    options={groupCodes
                        .map((x: any) => ({
                          label: x.code,
                          value: x.code,
                        }))
                        .sort(function (a, b) {
                          if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
                          if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
                          return 0;
                        })}
                    filterOption={(inputValue, option) =>
                        (option!.label as unknown as string)
                            .toUpperCase()
                            .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    filterSort={(optionA, optionB) =>
                        (optionA!.label as unknown as string)
                            .toLowerCase()
                            .localeCompare(
                                (optionB!.label as unknown as string).toLowerCase()
                            )
                    }>
                  </Select>
                </Form.Item>
              </Form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Account;
